var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchTerritories } from '../services/territoriesService';
const QUERY_KEYS = {
    all: ['territories'],
    list: () => ['territories', 'list'],
};
const sortByName = (items) => [...items].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
export function useTerritoriesQuery() {
    return useQuery({
        queryKey: QUERY_KEYS.list(),
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const data = yield fetchTerritories();
            return sortByName(data);
        }),
    });
}
export default function useTerritories(searchText) {
    const { data: territories = [], isLoading } = useTerritoriesQuery();
    const filteredTerritories = useMemo(() => {
        if (!searchText.trim())
            return territories;
        const lower = searchText.toLowerCase();
        return territories.filter((t) => t.name.toLowerCase().includes(lower));
    }, [searchText, territories]);
    return {
        territories: filteredTerritories,
        loading: isLoading,
    };
}
